<template>
  <div v-if="$store.getters.appInfo">
    <v-app-bar
      absolute
      elevation="0"
      class="app-style px-2 px-sm-10"
      :color="colorBar"
      style="min-height: 90px"
      dense
    >
      <div class="mt-4">
        <Logo />
      </div>
      <v-spacer></v-spacer>
      <div class="mt-10">
        <Language />
      </div>
      <div class="px-2 mt-10">
        <ProfileCustomer />
      </div>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: "MenuHeaderCustomer",

  data: () => ({}),
  computed: {
    colorBar() {
      if (this.$store.getters.appInfo.five) {
        return this.$store.getters.appInfo.five;
      } else {
        return "black";
      }
    },
  },
  methods: {
    logout: async function () {
      this.$store.dispatch("loading/start");
      await this.$store.dispatch("auth/logout");
      this.$router.push("/");
      this.$store.dispatch("loading/done");
    },
  },
};
</script>
